document.addEventListener('DOMContentLoaded', () => {
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  const priceElement = productInfo.querySelector('[id^="price-"]');
  const submitButton = productInfo.querySelector('[id^="ProductSubmitButton"]');
  const titleElement = productInfo.querySelector('.product__title h1, .product__title h2') || productInfo.querySelector('h1');
  const thumb = productInfo.querySelector('.product__media img');
  const infoContainer = productInfo.querySelector('.product__info-container');

  if (!submitButton || !priceElement || !infoContainer) return;

  const getPriceText = () => {
    const salePrice = priceElement.querySelector('.price__sale .price-item--sale');
    const regularPrice = priceElement.querySelector('.price__regular .price-item--regular');
    return (salePrice || regularPrice || priceElement).textContent.trim();
  };

  const bar = document.createElement('div');
  bar.className = 'floating-atc';
  bar.innerHTML = `
    <div class="floating-atc__inner">
      <div class="floating-atc__meta">
        <div class="floating-atc__thumb">${thumb ? thumb.cloneNode(true).outerHTML : ''}</div>
        <div>
          <p class="floating-atc__title">${titleElement ? titleElement.textContent.trim() : ''}</p>
          <p class="floating-atc__price">${getPriceText()}</p>
        </div>
      </div>
      <button type="button" class="button floating-atc__cta">${submitButton.textContent.trim()}</button>
    </div>
  `;

  document.body.appendChild(bar);

  const actionButton = bar.querySelector('.floating-atc__cta');
  actionButton?.addEventListener('click', () => submitButton.click());

  const updatePrice = () => {
    const barPrice = bar.querySelector('.floating-atc__price');
    if (barPrice) barPrice.textContent = getPriceText();
  };

  const priceObserver = new MutationObserver(updatePrice);
  priceObserver.observe(priceElement, { childList: true, subtree: true, characterData: true });

  const toggleBar = () => {
    const formBottom = infoContainer.getBoundingClientRect().bottom;
    const shouldShow = formBottom < 0;
    bar.classList.toggle('is-visible', shouldShow);
  };

  const throttledToggle = () => {
    if (toggleBar.rafScheduled) return;
    toggleBar.rafScheduled = true;
    requestAnimationFrame(() => {
      toggleBar();
      toggleBar.rafScheduled = false;
    });
  };

  window.addEventListener('scroll', throttledToggle, { passive: true });
  window.addEventListener('resize', throttledToggle);
  toggleBar();
});
